
(function () {
  function getCountry() {
    // Shopify setzt das in vielen Themes/Markets
    if (window.Shopify && Shopify.country) return Shopify.country;
    // fallback: html lang z.B. "de-CH"
    var lang = document.documentElement.lang || "";
    var m = lang.match(/-([A-Z]{2})$/i);
    return m ? m[1].toUpperCase() : "";
  }

  function hintText(isCH) {
    return isCH
      ? "Preis exkl. MwSt."
      : "Preis inkl. MwSt.";
  }

  function ensureHint(afterEl, isCH) {
    if (!afterEl || !afterEl.parentElement) return;

    // Entferne doppelte/alte Hints in diesem Block
    var scope = afterEl.closest(".card__information, .product__info-container, .price-wrapper, .card-information") || afterEl.parentElement;
    scope.querySelectorAll(".bfa-tax-hint").forEach(function (n) { n.remove(); });

    // Manche Themes rendern schon product__tax → löschen wir auf Cards, damit es nicht doppelt ist
    // (auf Produktseite lassen wir es optional stehen, aber du willst ja nur EINEN Hinweis)
    scope.querySelectorAll(".product__tax").forEach(function (n) { n.remove(); });

    var div = document.createElement("div");
    div.className = "bfa-tax-hint caption rte";
    div.textContent = hintText(isCH);
    afterEl.insertAdjacentElement("afterend", div);
  }

  function applyHints() {
    var isCH = getCountry() === "CH";

    // 1) Produktseite: nach dem Price-Wrapper / Price-Element
    document.querySelectorAll(".price-wrapper, .product__info-container .price, [id^='price-']").forEach(function (wrap) {
      // Wir wollen den Hinweis direkt nach dem sichtbaren Price Block
      var anchor = wrap.classList.contains("price-wrapper") ? wrap : wrap.closest(".price-wrapper") || wrap;
      ensureHint(anchor, isCH);
    });

    // 2) Katalog/Collection Cards: nach dem Price in der Card
    document.querySelectorAll(".card__information .price, .card__information .price-wrapper, .card-information .price").forEach(function (priceEl) {
      var anchor = priceEl.classList.contains("price-wrapper") ? priceEl : (priceEl.closest(".price-wrapper") || priceEl);
      ensureHint(anchor, isCH);
    });
  }

  // Initial
  document.addEventListener("DOMContentLoaded", applyHints);

  // Shopify Sections (Theme Editor / AJAX)
  document.addEventListener("shopify:section:load", applyHints);
  document.addEventListener("shopify:section:reorder", applyHints);

  // Variant changes (viele Themes feuern change events)
  document.addEventListener("change", function (e) {
    if (e.target && (e.target.name === "id" || e.target.closest("variant-selects") || e.target.closest("variant-radios"))) {
      setTimeout(applyHints, 50);
    }
  });

  // Fallback: manchmal rendert das Theme nachträglich → einmal nachziehen
  setTimeout(applyHints, 800);
})();